import {createAsyncThunk} from '@reduxjs/toolkit';

import {REPORT_CONFIGURATION_SLICE} from '../report-configuration-constants';
import {IReportConfigurationAttribute} from '../report-configuration-types';
import {getHeaderAttributes, getTableAttributes} from './report-dependencies-api';

export const loadTableAttributes = createAsyncThunk<
    IReportConfigurationAttribute[], {templateCode?: string}>(
        `${REPORT_CONFIGURATION_SLICE}/loadTableAttributes`,
        async ({templateCode}, {rejectWithValue}) => {
            if (!templateCode) return [];
            try {
                const tableAttributes = await getTableAttributes({templateCode});
                return tableAttributes.data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const loadHeaderAttributes = createAsyncThunk<
    IReportConfigurationAttribute[], {templateCode?: string}>(
        `${REPORT_CONFIGURATION_SLICE}/loadHeaderAttributes`,
        async ({templateCode}, {rejectWithValue}) => {
            if (!templateCode) return [];
            try {
                const tableAttributes = await getHeaderAttributes({templateCode});
                return tableAttributes;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );
